import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
// import store from "./store";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import "element-plus/es/components/message/style/css";
import "./assets/css/common.css";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";

const app = createApp(App);
app.use(router).use(ElementPlus, {
  locale: zhCn,
  size: "medium",
  zIndex: 3000,
});

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

app.mount("#app");
